import React from 'react';
import { Form, Header, Message, Button, Segment, Icon, Label } from 'semantic-ui-react';
import { buildObjectsArr } from '../../helper/helper.js';
import admHOC from './admHOC.js';

class AdmFormChannel extends React.Component {

  render() {
    const { formValues, formFieldValidity, submitAttempted } = this.props;
    const { keyEditable } = this.props;
    const disableButtons = this.props.processing || !formFieldValidity._form || !formValues.key;

    const actions = buildObjectsArr(this.props.actions);
    const tagsSys = buildObjectsArr(this.props.tagsSys);

    // TODO: need typecheck for array below in case of empty fields
    const optnActionId = actions.map( acy =>  ({text: acy.name, value: acy.key}) );
    const optnTagsSys = tagsSys.map( tag =>  ({text: tag.name, value: tag.key}) );

    return (
      <Form as='form'
        error={!formFieldValidity._form && submitAttempted}
        onReset={this.props.handleReset}
        onSubmit={ (e) => this.props.handleSubmit('channels', e) }
        >
        <Header dividing>
          <Icon name='desktop'/>
          <Header.Content>Channel</Header.Content>
          <Header.Subheader>Add, Edit or Delete</Header.Subheader>
        </Header>

          <Form.Input required name='key' label='Key'
            readOnly={!keyEditable}
            onChange={this.props.handleChange}
            error={!formFieldValidity.key && submitAttempted}
            value={formValues.key}
            placeholder='Key required, please choose on the left or click "add new"'
          />

          <Form.Checkbox name='published' label='published'
            checked={formValues.published}
            disabled
          />

        <Form.Input required name='name' label='Name'
          onChange={this.props.handleChange}
          error={!formFieldValidity.name && submitAttempted}
          value={formValues.name}
        />

        <Form.Group>
          <Form.Input required width={13} name='logo' label='Logo (icon name of semantic)'
          onChange={this.props.handleChange}
          error={!formFieldValidity.logo && submitAttempted}
          value={formValues.logo}
        />
          <Segment width={3} compact> <Icon size='large' name={formValues.logo} /> </Segment>
        </Form.Group>

        <Form.Group>
          <Form.Input required width={13} name='color' label='Color (in #hex, all UPPERCASE)'
          onChange={this.props.handleChange}
          pattern='[#]([\dA-F]{6}|[\dA-F]{3})'
          error={!formFieldValidity.color && submitAttempted}
          value={formValues.color}
        />
          <Label style={{backgroundColor: formValues.color}} size='mini' content='Color Prev' horizontal basic />
        </Form.Group>

        <Form.Group className='formGroup'>
          <Form.Input required width={12} name='url' label='Slug URL (must be unique)'
            onChange={this.props.handleChange}
            error={!formFieldValidity.url && submitAttempted}
            value={formValues.url}
          />
          { (this.props.checkIsUnique('channels', 'url', formValues.url))
            ? <Label basic pointing='left'><Icon name='check circle' color='green'/>Unique</Label>
            : <Label basic pointing='left' color='red'><Icon name='warning circle' color='red'  />in Use!</Label> }
        </Form.Group>

        <Form.Select search multiple disabled
          label='Actions' name='actionId' placeholder='Actions...'
          options={optnActionId} value={formValues.actionId || []}
          // onChange={this.props.handleChange}
        />
        <Form.Select search multiple
          label='System Tags' name='tagsSys' placeholder='System Tags...'
          options={optnTagsSys} value={formValues.tagsSys  || []} onChange={this.props.handleChange}
        />

        <Message error className='formMsg'>
          <Message.Header>You shall not pass!</Message.Header>
          <Message.List items={formFieldValidity._msgList} />
        </Message>

        <Button color='red' icon='trash' basic
          type='button'
          disabled={disableButtons}
          //the second endpoint argument is an array to unpublish all relatives referring to this id
          onClick={ (e) => this.props.confirmDeletion('channels', e, [], []) }
        />

        <Button.Group >
          <Button
            basic
            color='grey'
            type='reset'
            >
            Reset Form
          </Button>
          <Button
            primary
            disabled={disableButtons}
            type='submit'
            >
            Submit
          </Button>
        </Button.Group>

      </Form>
    );
  }

}

export default admHOC(AdmFormChannel);



// WEBPACK FOOTER //
// ./src/components/forms/AdmFormChannel.js